// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playlist-container {
    margin-top: 100px;
    margin-bottom: 50px;
    width: 100%;
    min-height: 300px;
}

.my-videos {
    /*margin-top: 100px;*/
    padding: 30px;
    border-radius: 16px;
    background-color: #ffff;
    /*height: 500px;*/
    /*margin-top: 40px;*/
    overflow-y: auto;
    overflow-x: hidden;
}
 
.like-cmt-select > select {
    height: 50px;
    font-size: 15px;
}

.like-cmt-select > span{
    position: absolute;
    font-size: 13px;
    left: 30px;
    top: 2px;
    color: #878787;
}

.like-cmt-select button span{
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #555;
    display: inline-block;
}

.like-cmt-select button{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    top: 25px;
    width: 50px;
    background-color: #f5f7f6;
}

.like-cmt-select button.sort-videos {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    /* left: 117px; */
    top: 25px;
    padding: 0;
    width: 26px;
    background-color: #f5f7f6;
}

.filter-btn{
    background-color: transparent;
    height: 50px;
    width: 100%;
    box-shadow: none;
    border-radius: 3px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 6px;
}


.filter-btn img {
    height: 17px;
}
.info{
    margin-bottom: 20px;
}

.info span {
 margin-right: 10px;
 font-size: 13px;
}

.info span.categories {
    color: #878787;
    font-size: 12px;
}

.video-container {
    width: 100%;
    padding: 0px 15px;
    padding: 15px 0;
    margin: 10px 50px;
    cursor: pointer;
}

.video-container:hover {
    background-color: #f8f9fa;
    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%);
    border-radius: 10px;
}

.video-container:hover .published-options {
    display: block;
    
}

.video-container:hover .published-options p,
.video-container:hover .published-options h5 {
    color: #878787;
}

.video-container:hover .published-views {
    display: none;
}

.published-options {
    /* display: none; */
    list-style-type: none;
}

.published-options p , h5 {
    color: #000000;
}

.published-options p {
    margin-bottom: 0px;
    margin-top: 0;
}

.published-options h5 {
    margin-top: 0;
    margin-bottom: 35px;
}

.published-options li a:hover {
    color: #6e5eff;
}

.published-views{
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.published-views li {
    display: inline-block;
    margin-right: 15px;
}

.draft-row {
    margin-bottom: 70px;
}

h5 {
    margin-top: 15px;
}
/********new********/


.img-box {
    display: flex;
    justify-content: center;
    height: 213px;
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 16px;
    width: 100%;
}

.img-box img {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

.two-btns {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 2px 10px;
    border-radius: 5px 10px;

}

.two-btns button {
    background-color: transparent;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
    border: none;
}

.two-btns button span {
    color: #fff;
    font-size: 17px !important;
}

.group-content {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 20px;
    /*margin-left: 80px;*/
    margin-left: 0px;
}
.group-content img {
    width: 100px;
    height: auto;
    border-radius: 10px;
}

.video-title {
    font-size: 16px;
    font-weight: 400;
}

.video-meta {
    font-size: 13px;
    font-weight: 400;
    color: #766a6a;
}

.content-page .content-area h4{
    font-weight: 400;
    font-size: 16px;
    color: #0f062b;
    margin-top: 15px;
    margin-bottom: 15px !important;
}


@media (max-width: 1600px) {
    .img-box {
        height: 150px
    }
}


@media (max-width: 1400px) {
    .img-box {
        height: 120px;
    }
}
@media (max-width: 1399px) {
    .video-container {
        margin: 0;
    }
    .group-content {
        /*margin-left: 30px;*/
        margin-left: 0px;
    }
}

@media (max-width: 991px) {
    .group-content {
        /*margin-left: 15px;*/
        margin-left: 0px;
    }
    .my-videos {
        padding: 12px;
    }

    .img-box {
        height: 240px;
    }
}

@media (max-width: 768px) {
    .img-box {
        height: 157px;
    }
}

@media (max-width: 420px) {
    .group-content {
        flex-direction: column;
        align-items: flex-start;
    }
    .img-box {
        height: 180px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/public-playlist/public-playlist.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,cAAc;;AAElB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA,oBAAoB;;;AAGpB;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;;AAE3B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,8BAA8B;AAClC;;;AAGA;IACI;QACI;IACJ;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,qBAAqB;QACrB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".playlist-container {\n    margin-top: 100px;\n    margin-bottom: 50px;\n    width: 100%;\n    min-height: 300px;\n}\n\n.my-videos {\n    /*margin-top: 100px;*/\n    padding: 30px;\n    border-radius: 16px;\n    background-color: #ffff;\n    /*height: 500px;*/\n    /*margin-top: 40px;*/\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n \n.like-cmt-select > select {\n    height: 50px;\n    font-size: 15px;\n}\n\n.like-cmt-select > span{\n    position: absolute;\n    font-size: 13px;\n    left: 30px;\n    top: 2px;\n    color: #878787;\n}\n\n.like-cmt-select button span{\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #555;\n    display: inline-block;\n}\n\n.like-cmt-select button{\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 16px;\n    top: 25px;\n    width: 50px;\n    background-color: #f5f7f6;\n}\n\n.like-cmt-select button.sort-videos {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    /* left: 117px; */\n    top: 25px;\n    padding: 0;\n    width: 26px;\n    background-color: #f5f7f6;\n}\n\n.filter-btn{\n    background-color: transparent;\n    height: 50px;\n    width: 100%;\n    box-shadow: none;\n    border-radius: 3px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-top: 6px;\n}\n\n\n.filter-btn img {\n    height: 17px;\n}\n.info{\n    margin-bottom: 20px;\n}\n\n.info span {\n margin-right: 10px;\n font-size: 13px;\n}\n\n.info span.categories {\n    color: #878787;\n    font-size: 12px;\n}\n\n.video-container {\n    width: 100%;\n    padding: 0px 15px;\n    padding: 15px 0;\n    margin: 10px 50px;\n    cursor: pointer;\n}\n\n.video-container:hover {\n    background-color: #f8f9fa;\n    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%);\n    border-radius: 10px;\n}\n\n.video-container:hover .published-options {\n    display: block;\n    \n}\n\n.video-container:hover .published-options p,\n.video-container:hover .published-options h5 {\n    color: #878787;\n}\n\n.video-container:hover .published-views {\n    display: none;\n}\n\n.published-options {\n    /* display: none; */\n    list-style-type: none;\n}\n\n.published-options p , h5 {\n    color: #000000;\n}\n\n.published-options p {\n    margin-bottom: 0px;\n    margin-top: 0;\n}\n\n.published-options h5 {\n    margin-top: 0;\n    margin-bottom: 35px;\n}\n\n.published-options li a:hover {\n    color: #6e5eff;\n}\n\n.published-views{\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.published-views li {\n    display: inline-block;\n    margin-right: 15px;\n}\n\n.draft-row {\n    margin-bottom: 70px;\n}\n\nh5 {\n    margin-top: 15px;\n}\n/********new********/\n\n\n.img-box {\n    display: flex;\n    justify-content: center;\n    height: 213px;\n    position: relative;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-radius: 16px;\n    width: 100%;\n}\n\n.img-box img {\n    height: 100%;\n    object-fit: cover;\n    cursor: pointer;\n}\n\n.two-btns {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #000000a2;\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    padding: 2px 10px;\n    border-radius: 5px 10px;\n\n}\n\n.two-btns button {\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    column-gap: 5px;\n    border: none;\n}\n\n.two-btns button span {\n    color: #fff;\n    font-size: 17px !important;\n}\n\n.group-content {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-top: 20px;\n    /*margin-left: 80px;*/\n    margin-left: 0px;\n}\n.group-content img {\n    width: 100px;\n    height: auto;\n    border-radius: 10px;\n}\n\n.video-title {\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.video-meta {\n    font-size: 13px;\n    font-weight: 400;\n    color: #766a6a;\n}\n\n.content-page .content-area h4{\n    font-weight: 400;\n    font-size: 16px;\n    color: #0f062b;\n    margin-top: 15px;\n    margin-bottom: 15px !important;\n}\n\n\n@media (max-width: 1600px) {\n    .img-box {\n        height: 150px\n    }\n}\n\n\n@media (max-width: 1400px) {\n    .img-box {\n        height: 120px;\n    }\n}\n@media (max-width: 1399px) {\n    .video-container {\n        margin: 0;\n    }\n    .group-content {\n        /*margin-left: 30px;*/\n        margin-left: 0px;\n    }\n}\n\n@media (max-width: 991px) {\n    .group-content {\n        /*margin-left: 15px;*/\n        margin-left: 0px;\n    }\n    .my-videos {\n        padding: 12px;\n    }\n\n    .img-box {\n        height: 240px;\n    }\n}\n\n@media (max-width: 768px) {\n    .img-box {\n        height: 157px;\n    }\n}\n\n@media (max-width: 420px) {\n    .group-content {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    .img-box {\n        height: 180px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
